import React from 'react';
import clsx from 'clsx';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { validate } from '@utils';

import InfoLightIcon from '@assets/icons/info-light.svg';
import SelectedIcon from '@assets/icons/tick.svg';

import useStyles from './style';

const noop = () => {};

const validateElement = (value, validations, type) => {
  let error = null;
  if (validations) {
    Object.keys(validations).forEach(key => {
      const validationResult = validate(value, key, validations[key], type);
      if (!validationResult.isValid && !error) {
        error = validationResult.errorMessage;
        return;
      }
    });
  }

  return error;
};

const validateForNumber = (event, type, value) => {
  if (type === 'number' && value) {
    const parsedValue = parseInt(value);
    // Converting to string before comparison because firefox gives false regardless of the value.
    if (parsedValue.toString() === 'NaN') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  }
};

const Input = ({
  autocomplete = 'off',
  considerValid = [],
  getOptionValue = () => '',
  hasError,
  helperText = '',
  hideError = false,
  margin = 'dense',
  onChange = noop,
  // onPaste = noop,
  // onKeyPress = noop,
  options = [],
  tooltip = '',
  tooltipPlacement = 'top',
  type = 'text',
  validations = {},
  value = '',
  variant = 'outlined',
  wrapperClassName = '',
  ...restProps
}) => {
  const passedClasses = useStyles();
  const [error, setError] = React.useState('');
  const selectedOption = options.find(option => option.isSelected) || {};
  return (
    <div
      className={clsx(
        'd-flex',
        {
          'w-100': restProps.fullWidth,
        },
        wrapperClassName
      )}
      data-testid='input-wrapper'
    >
      <TextField
        margin='dense'
        {...restProps}
        classes={{
          ...restProps.classes,
          root: `input-field ${restProps.classes?.root}`,
        }}
        autoComplete={autocomplete}
        error={!!error || hasError}
        helperText={(!hideError && error) || helperText}
        InputProps={{
          ...restProps?.InputProps,
          classes: {
            ...restProps?.InputProps?.classes,
            input: passedClasses.placeholder,
          },
        }}
        onChange={event => {
          const value = event.currentTarget.value;
          if (options.length > 0) {
            onChange(options[event.currentTarget.getAttribute('option')], null);
            setError(null);
            return;
          }

          const error = validateElement(value, validations);
          if (considerValid.indexOf(value) === -1) {
            setError(error);

            onChange(event, error);
          } else {
            setError(null);

            onChange(event, null);
          }
        }}
        onKeyPress={event => {
          validateForNumber(event, type, event.currentTarget.value);
        }}
        onPaste={event => {
          const pastedValue = event.clipboardData.getData('text/plain');
          validateForNumber(event, type, pastedValue);
        }}
        select={options.length > 0}
        type={type}
        margin={margin}
        {...((value !== undefined && value !== null) ||
        (options.length > 0 && Object.keys(selectedOption).length > 0)
          ? {
              value:
                options.length > 0
                  ? typeof selectedOption.label === 'string'
                    ? selectedOption.label
                    : getOptionValue(selectedOption)
                  : value,
            }
          : {})}
        variant={variant}
      >
        {options.map((option, optionIndex) => (
          <MenuItem
            key={`${restProps.placeholder || restProps.label}-${option.id ||
              optionIndex}-option`}
            value={
              typeof option.label === 'string'
                ? option.label
                : getOptionValue(option)
            }
            option={optionIndex}
            data-testid='input-menu-item'
          >
            {/* <div className='d-flex'> */}
            {/* {option.isSelected && (
                <img alt='' className='mr-3' src={SelectedIcon} />
              )} */}
            {option.label}
            {/* </div> */}
          </MenuItem>
        ))}
      </TextField>
      {tooltip && (
        <Tooltip
          className='ml-2'
          title={tooltip}
          placement={tooltipPlacement}
          data-testid='input-tooltip'
        >
          <img src={InfoLightIcon} alt='field tooltip' className='info-icon' />
        </Tooltip>
      )}
    </div>
  );
};

export default Input;
